module.exports = __webpack_public_path__ + "img/lawContrant3.15229563.png";